import { render } from "./paw.vue?vue&type=template&id=150e4dd3&scoped=true"
import script from "./paw.vue?vue&type=script&lang=ts"
export * from "./paw.vue?vue&type=script&lang=ts"

import "./paw.vue?vue&type=style&index=0&id=150e4dd3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-150e4dd3"

export default script